// Submit handler for the #contact demo request form. Posts to the
// /api/contact Pages Function; without this the form is inert and a click on
// "Send Message" just reloads the page with the fields in the query string.
const ENDPOINT = "/api/contact"

document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("contact-form")
  if (!form) return

  const status = document.getElementById("contact-status")
  const button = form.querySelector("button[type=submit]")
  const originalLabel = button.textContent

  form.addEventListener("submit", async (event) => {
    event.preventDefault()

    button.disabled = true
    button.textContent = "Sending…"
    show(status, "Sending your request…", "text-kdm-gray-light")

    let response
    try {
      response = await fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(Object.fromEntries(new FormData(form))),
      })
    } catch (error) {
      reset(button, originalLabel)
      show(status, "Network error — please check your connection or email us directly.", "text-red-400")
      throw error
    }

    const body = await response.json().catch(() => ({}))

    if (response.ok) {
      form.reset()
      button.textContent = "Sent"
      show(status, "Thanks — we'll be in touch shortly.", "text-kdm-blue-bright")
      return
    }

    reset(button, originalLabel)
    show(status, body.error || "Something went wrong — please email us directly.", "text-red-400")
  })
})

function reset(button, label) {
  button.disabled = false
  button.textContent = label
}

function show(status, message, colorClass) {
  if (!status) return
  status.textContent = message
  status.className = `text-center text-sm ${colorClass}`
}
